import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {connect} from 'react-redux';
import exclamationMark from './images/exclamationMark.svg';
import BtnPink from '../../Shared/Buttons/BtnPink';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import {
  doTvActivationCodeRecovery,
  generateUserPasswordTv,
  tvActivationCodeRecoverySms,
  setIsPasswordUpdate,
  reportDWH,
} from './TvActivationCodeRecoveryBlockSlice';
import Config from 'app/Config';
import success from './images/success.svg';
import appstore from './images/appstore.svg';
import googlePlay from './images/google-play.svg';
import {buildUrlAndOpenWindow} from 'app/utilities/StringHelpers/StringHelpers';

const PopupContent = (props) => {
  if (!props.contentType) return null;

  const onClickLoginDetails = async () => {
    try {
      const res = await props.tvActivationCodeRecoverySms(props.selectedCustomer.ban);
      if (res.payload) {
        props.reportDWH({actionType: 'TV Code Sending', status: 'Completed', messageText: 'TV Code Sending Success'});
        props.setPopupType('successMessagePopUp');
      }
    } catch (error) {
      console.error('Error sending TV code:', error);
      props.setPopupType('errorMessagePopUp');
    }
  };

  const onClickchangePassword = async () => {
    try {
      const dataToSend = {
        ban: props.selectedCustomer.ban,
        tvCode: props.infoTv.tvCode,
      };
      const res = await props.generateUserPasswordTv(dataToSend);
      if (res.payload.result.isSuccess) {
        props.reportDWH({actionType: 'TV Code Update', status: 'Completed', messageText: 'TV Code Update Success'});
        props.setPopupType('changePasswordPopUp');
      } else {
        props.reportDWH({actionType: 'TV Code Update', status: 'Error', messageText: 'TV Code Update Eror'});
      }
    } catch (error) {
      console.error('שגיאה ביצירת הסיסמה:', error);
    }
  };

  const reset = () => {
    props.setPopupType(null);
    props.setIsPasswordUpdate(true);
  };

  const onClickDownload = (item) => {
    props.reportDWH({actionType: 'TV Code APP Download', status: 'Completed', messageText: 'TV Code APP Download Display'});
    if (item === 'android') {
      buildUrlAndOpenWindow(Config.androidTvApplicationUrl);
    } else {
      buildUrlAndOpenWindow(Config.iosTvApplicationUrl);
    }
  };

  const getPopupContent = () => {
    switch (props.contentType) {
      case 'passwordResetPopUp':
        return (
          <>
            <Image alt='image' src={exclamationMark} />
            <div className='title'> בטוחים שאתם רוצים לאפס את הסיסמה? </div>
            <div className='sub-title'>אחרי האיפוס תצטרכו להתחבר מחדש מכל המכשירים שמחוברים עכשיו ל{window.Config.brand_Name_HE} TV</div>
            <div className='wrapper-buttons'>
              <BtnPink onclick={onClickchangePassword} text='תאפסו לי את הסיסמא' />
              <BtnWhite text='חזרה' onclick={() => props.setPopupType(null)} />
            </div>
          </>
        );
      case 'changePasswordPopUp':
        return (
          <>
            <div className='title'>שינוי סיסמה ל{window.Config.brand_Name_HE} TV</div>
            <div className='passport'>
              סיסמא ישנה: <span>{props.infoTv.tvCode}</span>
            </div>
            <div className='new-passport'>
              <div>יצרנו עבורכם סיסמה חדשה</div>
              <div>{props.activationCode}</div>
            </div>
            <button className='link-button' onClick={() => props.setPopupType('sendingCodePopUp')}>
              לשליחת הסיסמה במייל וב-SMS
            </button>
            <BtnPink onclick={() => reset()} text='סיום' />
          </>
        );
      case 'sendingCodePopUp':
        return (
          <>
            <div className='title'>שליחת פרטי כניסה</div>
            <BtnPink onclick={() => onClickLoginDetails()} text='שלח' />
          </>
        );
      case 'downloadingAppPopUp':
        return (
          <div className='downloading-app-popUp'>
            <div className='info-caption'>
              <div className='title'> הורדת האפליקציה של {window.Config.brand_Name_HE} מחנות האפליקציות למכשיר שלכם:</div>
            </div>
            <div className='info-link-wrapper'>
              <button className='info-link' onClick={() => onClickDownload('android')}>
                <Image src={googlePlay} alt='image' />
              </button>
              <button className='info-link' onClick={() => onClickDownload('ios')}>
                <Image src={appstore} alt='image' />
              </button>
            </div>
          </div>
        );
      case 'successMessagePopUp':
        return (
          <>
            <Image src={success} />
            <div className='title'>הפרטים נשלחו בהצלחה!</div>
            <div className='info-sending-code'>
              <div className='info-sending-code-item'>
                {props.tvParameters?.eMail && <div>למייל </div>}
                <div className='info-sending-code-text'>{props.tvParameters?.eMail}</div>
              </div>
              <div className='info-sending-code-item'>
                {props.tvParameters?.phoneNo && <div>ולמספר</div>}
                <div className='info-sending-code-text'>{props.tvParameters?.phoneNo}</div>
              </div>
            </div>
            <BtnPink onclick={() => props.setPopupType(null)} text='סיום' />
          </>
        );
      case 'errorMessagePopUp':
        return (
          <>
            <Image src={exclamationMark} />
            <div className='title'>מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת</div>
            <BtnPink onclick={() => reset(props)} text='סיום' />
          </>
        );
      default:
        return null;
    }
  };

  return <div className='popup-content'>{getPopupContent()}</div>;
};

const mapStateToProps = (state) => ({
  selectedCustomer: state.TvActivationCodeRecovery.selectedCustomer,
  isSuccsess: state.TvActivationCodeRecovery.isSuccsess,
  infoTv: state.TvActivationCodeRecovery.infoTv,
  activationCode: state.TvActivationCodeRecovery.activationCode,
  tvParameters: state.TvActivationCodeRecovery.tvParameters,
});

const mapDispatchToProps = {
  doTvActivationCodeRecovery,
  generateUserPasswordTv,
  setIsPasswordUpdate,
  reportDWH,
  tvActivationCodeRecoverySms,
};

export default connect(mapStateToProps, mapDispatchToProps)(PopupContent);
